module.exports = __webpack_public_path__ + "static/media/demo3.d931b22c.jpg";